import { render, staticRenderFns } from "./AffiliateCompaniesSetup.vue?vue&type=template&id=686e54a0&scoped=true&"
import script from "./AffiliateCompaniesSetup.vue?vue&type=script&lang=js&"
export * from "./AffiliateCompaniesSetup.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateCompaniesSetup.vue?vue&type=style&index=0&id=686e54a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686e54a0",
  null
  
)

export default component.exports